export default filter =>
  Object.keys(filter).reduce((query, taxonomy) => {
    Object.keys(filter[taxonomy]).forEach(categoryKey => {
      if (filter[taxonomy][categoryKey])
        query.push(`${taxonomy}/${categoryKey}`)
    })
    return query
  }, [])
